import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';

export const ScrollReveal = ({ children, className = '', stagger = 0 }) => {
  const ref = useScrollReveal();
  
  const staggerClass = stagger > 0 ? `stagger-${stagger}` : '';
  
  return (
    <div ref={ref} className={`scroll-reveal ${staggerClass} ${className}`}>
      {children}
    </div>
  );
};
